var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upgrade-dialog"},_vm._l((_vm.previewList),function(item){return _c('ImagePreviewer',{key:item.previewKey,attrs:{"currentImage":item.largeImage,"imageList":item.largeImageArray},on:{"close":function($event){return _vm.closePreview(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }